import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "sonner";
import { Eyebrow, Reveal } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const WA = "https://wa.me/628113030918?text=Halo%2C%20saya%20ingin%20konsultasi%20proyek";

const SERVICES = [
    "Kaca & Aluminium",
    "Fasad & Kaca Structural",
    "Partisi Kaca",
    "Shower Glass",
    "Desain Interior",
    "Kitchen Set & Custom",
    "Lainnya",
];

const initial = { name: "", phone: "", service: SERVICES[0], message: "" };

export default function Contact() {
    const [form, setForm] = useState(initial);
    const [sending, setSending] = useState(false);

    const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

    const submit = async (e) => {
        e.preventDefault();
        if (sending) return;
        setSending(true);
        try {
            await axios.post(`${API}/contact`, form);
            toast.success("Pesan terkirim. Kami akan menghubungi Anda kembali.");
            setForm(initial);
        } catch (err) {
            toast.error("Gagal mengirim pesan. Coba lagi atau chat via WhatsApp.");
        } finally {
            setSending(false);
        }
    };

    return (
        <section id="kontak" className="border-t border-white/10 bg-surface/40 py-24 lg:py-32">
            <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-16 px-6 lg:grid-cols-2 lg:gap-24 lg:px-10">
                <div>
                    <Reveal>
                        <Eyebrow>Kontak</Eyebrow>
                    </Reveal>
                    <Reveal delay={0.05}>
                        <h2 className="mt-6 font-serif text-4xl font-medium leading-tight text-white lg:text-6xl">
                            Punya rencana?
                            <br />
                            <span className="italic text-chrome">
                                Mari kita ukur.
                            </span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <p className="mt-6 max-w-md text-base leading-relaxed text-zinc-400">
                            Ceritakan proyek Anda — kanopi, partisi, fasad,
                            atau penataan interior. Konsultasi awal dan survei
                            lokasi gratis, tanpa komitmen.
                        </p>
                    </Reveal>
                    <Reveal delay={0.15}>
                        <div className="mt-10 space-y-4">
                            <a
                                href={WA}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="contact-whatsapp-cta"
                                className="inline-flex items-center gap-3 rounded-full bg-gold px-8 py-4 font-mono text-xs font-medium uppercase tracking-[0.18em] text-black transition-transform duration-300 hover:-translate-y-0.5 hover:bg-[#e5c14e]"
                            >
                                <svg
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    className="h-4 w-4"
                                    aria-hidden="true"
                                >
                                    <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21 5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2zm0 18.03c-1.53 0-3.03-.41-4.34-1.19l-.31-.18-3.12.82.83-3.04-.2-.33a8.06 8.06 0 0 1-1.23-4.3c0-4.54 3.7-8.23 8.24-8.23 4.54 0 8.23 3.69 8.23 8.23s-3.69 8.22-8.1 8.22zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.4-.12-.56.13-.17.25-.64.81-.78.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.01-.38.11-.51.11-.11.25-.29.37-.43.12-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.35-.77-1.85-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.25.25-.85.83-.85 2.02s.87 2.35.99 2.51c.12.17 1.71 2.61 4.15 3.66.58.25 1.03.4 1.38.51.58.18 1.1.16 1.52.1.46-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.14-1.18-.06-.1-.22-.16-.47-.29z" />
                                </svg>
                                Chat via WhatsApp
                            </a>
                            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">
                                Respon cepat di jam kerja · Rumah · Ruko ·
                                Kantor · Retail
                            </p>
                        </div>
                    </Reveal>
                </div>

                <Reveal delay={0.1}>
                    <form
                        onSubmit={submit}
                        data-testid="contact-form"
                        className="border border-white/10 bg-elevated/60 p-8 lg:p-12"
                    >
                        <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">
                            Formulir Proyek
                        </div>

                        <div className="mt-8 space-y-7">
                            <div>
                                <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">
                                    Nama
                                </label>
                                <input
                                    required
                                    value={form.name}
                                    onChange={set("name")}
                                    data-testid="contact-input-name"
                                    placeholder="Nama Anda"
                                    className="field-architect mt-1 text-sm"
                                />
                            </div>
                            <div>
                                <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">
                                    No. WhatsApp
                                </label>
                                <input
                                    required
                                    type="tel"
                                    value={form.phone}
                                    onChange={set("phone")}
                                    data-testid="contact-input-phone"
                                    placeholder="08xxxxxxxxxx"
                                    className="field-architect mt-1 text-sm"
                                />
                            </div>
                            <div>
                                <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">
                                    Kebutuhan
                                </label>
                                <select
                                    value={form.service}
                                    onChange={set("service")}
                                    data-testid="contact-input-service"
                                    className="field-architect mt-1 text-sm"
                                >
                                    {SERVICES.map((s) => (
                                        <option key={s}>{s}</option>
                                    ))}
                                </select>
                            </div>
                            <div>
                                <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">
                                    Ceritakan Proyeknya
                                </label>
                                <textarea
                                    required
                                    rows={3}
                                    value={form.message}
                                    onChange={set("message")}
                                    data-testid="contact-input-message"
                                    placeholder="Contoh: butuh kanopi kaca teras ukuran 3x4 m"
                                    className="field-architect mt-1 resize-none text-sm"
                                />
                            </div>
                        </div>

                        <motion.button
                            whileTap={{ scale: 0.98 }}
                            type="submit"
                            disabled={sending}
                            data-testid="contact-submit-button"
                            className="mt-10 w-full rounded-full bg-gold py-4 font-mono text-xs font-medium uppercase tracking-[0.2em] text-black transition-colors duration-300 hover:bg-[#e5c14e] disabled:opacity-60"
                        >
                            {sending ? "Mengirim…" : "Kirim Permintaan Konsultasi"}
                        </motion.button>
                    </form>
                </Reveal>
            </div>
        </section>
    );
}
